/* LLS cart drawer (phase 1, 2026-10-16). Loader + kill switch: snippets/lls-cart.liquid.
   Data: snippets/lls-cart-json.liquid, returned with every cart mutation via sections=lls-cart-data,
   so the drawer renders from the add/change response itself and never reloads /cart.js. */
(function () {
  'use strict';
  if (!window.__llsCartOn || window.__llsCart) return;
  var CFG = window.__llsCartCfg || {};
  var SHOW = CFG.show || {};
  var SEC = 'lls-cart-data';
  var _fetch = window.fetch.bind(window);
  var st = { expect: 0, adding: false, data: null, seq: 0, applied: 0, t: 0, isOpen: false, err: '', pending: 0, waiters: [], lastFocus: null };
  var pv = null;
  try { var th = window.Shopify && window.Shopify.theme; if (th && th.role && th.role !== 'main' && th.id) pv = th.id; } catch (e) {}
  var root = (CFG.root || '/').replace(/\/?$/, '/');

  /* ---------- data ---------- */
  function parse(html) {
    if (!html) return null;
    var m = String(html).match(/<script[^>]*data-lls-cart-json[^>]*>([\s\S]*?)<\/script>/);
    if (!m) return null;
    try { return JSON.parse(m[1]); } catch (e) { return null; }
  }
  function initial() {
    var el = document.querySelector('script[data-lls-cart-json]');
    var d = el ? parse(el.outerHTML) : null;
    return d || { count: 0, items: [], pairs: [], gap: [], currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' };
  }
  function secUrl() { return location.pathname + (pv ? '?preview_theme_id=' + pv : ''); }
  function ingest(html, seq) {
    var d = parse(html);
    if (!d) return false;
    if (seq < st.applied) return true; /* an older response landed late */
    st.applied = seq; st.data = d; st.t = Date.now();
    render(); bubble(); refreshCodes();
    return true;
  }
  function begin() { st.pending++; }
  function end() { st.pending = Math.max(0, st.pending - 1); if (!st.pending) { var w = st.waiters; st.waiters = []; w.forEach(function (f) { f(); }); } }
  function settled() { return st.pending ? new Promise(function (r) { st.waiters.push(r); setTimeout(r, 2500); }) : Promise.resolve(); }
  function fetchData(seq) {
    seq = seq || ++st.seq; begin();
    return _fetch(root + '?sections=' + SEC + (pv ? '&preview_theme_id=' + pv : ''), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { ingest(j && j[SEC], seq); })
      .catch(function () {})
      .then(end);
  }

  /* Every cart mutation on the page (buy box, FBT, quiz, gift manager, theme forms) gets our section
     added to its request, so the drawer data arrives in the same response. */
  var MUT = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function withSections(body) {
    if (body == null) return { body: body, ok: false };
    if (typeof body === 'string') {
      var s = body.trim();
      if (s.charAt(0) === '{') {
        var o = JSON.parse(s);
        if (!o.sections) o.sections = SEC;
        else if (Array.isArray(o.sections)) { if (o.sections.indexOf(SEC) < 0) o.sections.push(SEC); }
        else if (String(o.sections).split(',').indexOf(SEC) < 0) o.sections = o.sections + ',' + SEC;
        if (!o.sections_url) o.sections_url = secUrl();
        return { body: JSON.stringify(o), ok: true };
      }
      if (/(^|&)sections=/.test(s)) return { body: body, ok: false };
      return { body: s + (s ? '&' : '') + 'sections=' + SEC + '&sections_url=' + encodeURIComponent(secUrl()), ok: true };
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (body.has('sections')) { var cur = String(body.get('sections')); if (cur.split(',').indexOf(SEC) < 0) body.set('sections', cur + ',' + SEC); }
      else body.append('sections', SEC);
      if (!body.has('sections_url')) body.append('sections_url', secUrl());
      return { body: body, ok: true };
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      if (!body.has('sections')) { body.append('sections', SEC); body.append('sections_url', secUrl()); return { body: body, ok: true }; }
    }
    return { body: body, ok: false };
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) || (input && input.method) || 'GET';
    if (!MUT.test(url) || !/post/i.test(method) || (init && init.__lls)) return _fetch(input, init);
    var seq = ++st.seq, injected = false;
    /* A shopper's own add (buy box, sticky bar, FBT, answer block): open at once in an "adding" state
       instead of waiting ~1s for the add to return. Automatic adds (gift manager) never open it. */
    var userAdd = /\/cart\/add/.test(url) && Date.now() - st.expect < 1500;
    if (userAdd) { st.expect = 0; st.adding = true; try { st.pend = pendingFrom(init && init.body); } catch (e) { st.pend = []; } open(); }
    if (init && typeof input === 'string') {
      try { var w = withSections(init.body); if (w.ok) { init = Object.assign({}, init, { body: w.body }); injected = true; } } catch (e) {}
    }
    begin();
    var p = _fetch(input, init);
    p.then(function (r) {
      if (userAdd) { st.adding = false; st.pend = null; if (!r.ok) { close(); return fetchData(seq); } }
      if (!r.ok || !injected) return fetchData(seq);
      return r.clone().json().then(function (j) { if (!ingest(j && j.sections && j.sections[SEC], seq)) return fetchData(seq); });
    }).catch(function () { if (userAdd) { st.adding = false; st.pend = null; close(); } return fetchData(seq); }).then(end);
    return p;
  };
  try {
    var xo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { if (MUT.test(u || '') && /post/i.test(m || '')) this.addEventListener('loadend', function () { fetchData(); }); } catch (e) {}
      return xo.apply(this, arguments);
    };
  } catch (e) {}

  /* 2026-10-20 (Ben: the drawer opens fast but the item takes a couple of seconds to appear):
     Shopify's add.js takes 0.5-1s+ on its own, so while it runs we show the product being added
     straight away from what the page already knows (variant name/price from ShopifyAnalytics meta,
     the gallery image, or the drawer's own pairing data). Checkout stays disabled until it lands. */
  function pendingFrom(body) {
    var raw = [];
    if (typeof body === 'string') {
      var s = body.trim();
      if (s.charAt(0) === '{') { var o = JSON.parse(s); raw = o.items || (o.id ? [o] : []); }
      else { var u = new URLSearchParams(s); if (u.get('id')) raw = [{ id: u.get('id'), quantity: u.get('quantity'), selling_plan: u.get('selling_plan') }]; }
    } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (body.get('id')) raw = [{ id: body.get('id'), quantity: body.get('quantity'), selling_plan: body.get('selling_plan') }];
    }
    var meta = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || null;
    var d = st.data || {}, pool = (d.pairs || []).concat(d.gap || []);
    var gimg = document.querySelector('.product__media img, .product-media-container img, [class*="gallery"] img, .lls-m-gallery img');
    return raw.map(function (r) {
      var id = +r.id, q = +r.quantity || 1, plan = r.selling_plan ? +r.selling_plan : 0, x = null;
      lines().forEach(function (l) { if (!x && +l.id === id) x = { title: l.title, img: l.img, price: plan ? 0 : l.price }; });
      if (!x && meta) meta.variants.forEach(function (v) { if (!x && +v.id === id) x = { title: v.name, img: gimg ? (gimg.currentSrc || gimg.src) : '', price: plan ? 0 : v.price }; });
      if (!x) pool.forEach(function (pp) { (pp.variants && pp.variants.length ? pp.variants : [{ id: pp.id }]).forEach(function (v) { if (!x && +v.id === id) x = { title: pp.title, img: pp.img, price: plan ? 0 : (v.price || pp.price) }; }); });
      if (!x) return null;
      x.qty = q; return x;
    }).filter(Boolean);
  }
  function pendHtml(x) {
    return '<div class="llc-line llc-line--pend"><span class="llc-img">' + (x.img ? '<img src="' + esc(img(x.img, 160)) + '" alt="" width="64" height="64">' : '') + '</span>'
      + '<div class="llc-info"><span class="llc-t">' + esc(x.title) + '</span><span class="llc-pill"><span class="llc-spin" aria-hidden="true"></span> Adding' + (x.qty > 1 ? ' ' + x.qty : '') + '</span></div>'
      + '<div class="llc-pr">' + (x.price ? money(x.price * x.qty) : '') + '</div></div>';
  }

  function api(path, payload) {
    payload.sections = SEC; payload.sections_url = secUrl();
    var seq = ++st.seq; begin(); setBusy(true); st.err = '';
    return _fetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) { st.err = (j && (j.description || j.message)) || 'Sorry, that did not work. Please try again.'; return fetchData(seq); }
          if (!ingest(j && j.sections && j.sections[SEC], seq)) return fetchData(seq);
        });
      })
      .catch(function () { st.err = 'Sorry, that did not work. Please try again.'; return fetchData(seq); })
      .then(function () { setBusy(false); end(); render(); try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {} });
  }

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    var d = st.data || {}, cur = d.currency || 'GBP';
    var n = (c || 0) / 100;
    try { return new Intl.NumberFormat(cur === 'USD' ? 'en-US' : 'en-GB', { style: 'currency', currency: cur }).format(n); }
    catch (e) { return (d.symbol || '£') + n.toFixed(2); }
  }
  function moneyShort(c) { return (c % 100 === 0) ? money(c).replace(/\.00$/, '') : money(c); }
  function img(u, w) { if (!u) return ''; return u.replace(/width=\d+/, 'width=' + (w || 160)); }
  function every(n) { return n === 1 ? 'Every month' : 'Every ' + n + ' months'; }
  function monthsIn(name) {
    var s = String(name || '').toLowerCase();
    var m = s.match(/every (\d+) month/); if (m) return +m[1];
    if (/every month/.test(s)) return 1;
    return 0;
  }
  function kind(it) {
    if (it.gift) return 'gift';
    if (!it.plan_id) return 'once';
    if (/delivered together/i.test(it.plan)) return 'pack';
    if (/paid upfront/i.test(it.plan)) return 'prepaid';
    return 'sub';
  }
  function planText(it) {
    var k = kind(it), n = monthsIn(it.plan), a = it.adj || [];
    if (k === 'pack') return 'Delivered together, ' + (n ? every(n).toLowerCase() : '') + ' · save ' + (a[0] || 20) + '%';
    if (k === 'prepaid') return it.plan;
    if (k === 'sub') {
      if (a.length === 2 && +a[0] < +a[1]) return (n ? every(n) + ' · ' : '') + a[0] + '% off now, ' + a[1] + '% from your 2nd delivery';
      return (n ? every(n) + ' · ' : '') + 'save ' + (a[0] || 0) + '%';
    }
    return '';
  }
  function firstSentence(s) { s = String(s || '').trim(); var m = s.match(/^.*?[.!?](\s|$)/); s = m ? m[0].trim() : s; return s.length > 120 ? s.slice(0, 117).replace(/\s+\S*$/, '') + '...' : s; }
  function track(name, props) {
    props = props || {};
    try { if (window.gtag) window.gtag('event', 'lls_cart_' + name, props); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'lls_cart_' + name }, props)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('lls_cart_' + name, props); } catch (e) {}
  }
  function lines() { return ((st.data && st.data.items) || []); }
  function realLines() { return lines().filter(function (i) { return !i.gift; }); }
  function mainLine() {
    var d = st.data || {}, best = null;
    realLines().forEach(function (i) { if (i.handle === d.main && !best) best = i; });
    return best || realLines()[0] || null;
  }
  function market() {
    var d = st.data || {};
    if (d.currency === 'GBP') return 'uk';
    if (d.currency === 'USD') {
      var rl = realLines();
      if (rl.length && rl.every(function (i) { return i.us; })) return 'us';
    }
    return 'other';
  }
  function freeThreshold() {
    var m = market();
    if (m === 'uk') return (CFG.freeUk || 5000) + 1; /* rate is "over £50": £50.00 still pays */
    if (m === 'us') {
      var rate = 0; try { rate = parseFloat(Shopify.currency.rate); } catch (e) {}
      if (!(rate > 0)) return 0;
      return Math.ceil((CFG.freeUsGbp || 3709) * rate);
    }
    return 0;
  }

  /* ---------- render ---------- */
  var el = {};
  function build() {
    if (el.root) return;
    var ov = document.createElement('div'); ov.className = 'llc-ov'; ov.setAttribute('data-llc', 'close');
    var a = document.createElement('aside');
    a.className = 'llc'; a.id = 'lls-cart'; a.setAttribute('role', 'dialog'); a.setAttribute('aria-modal', 'true'); a.setAttribute('aria-label', 'Your basket'); a.setAttribute('aria-hidden', 'true'); a.tabIndex = -1;
    a.innerHTML = '<header class="llc-hd"><h2 class="llc-h">Your basket <span class="llc-n"></span></h2><button type="button" class="llc-x" data-llc="close" aria-label="Close basket"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button></header><div class="llc-body"></div><footer class="llc-ft"></footer>';
    document.body.appendChild(ov); document.body.appendChild(a);
    el.ov = ov; el.root = a; el.body = a.querySelector('.llc-body'); el.ft = a.querySelector('.llc-ft'); el.n = a.querySelector('.llc-n');
    a.addEventListener('click', onClick); ov.addEventListener('click', close);
    a.addEventListener('change', onChange);
    a.addEventListener('submit', onSubmit); a.addEventListener('input', onInput);
  }
  function setBusy(b) { if (el.root) el.root.classList.toggle('llc--busy', !!b); }

  function rewardHtml() {
    if (SHOW.reward === false) return '';
    var d = st.data || {}, m = market();
    if (m === 'other') return '';
    var rl = realLines(); if (!rl.length) return '';
    var subs = rl.filter(function (i) { var k = kind(i); return k === 'sub' || k === 'pack' || k === 'prepaid'; });
    var hasPack = rl.some(function (i) { var k = kind(i); return k === 'pack' || k === 'prepaid'; });
    var once = rl.filter(function (i) { return kind(i) === 'once'; });
    var place = m === 'uk' ? 'UK delivery' : 'US shipping';
    var tick = '<span class="llc-tick" aria-hidden="true">✓</span>';
    if (subs.length) {
      var top = '<div class="llc-rw-row">' + tick + (once.length ? 'Free ' + place + ' on your subscription items' : 'Free ' + place + ' on every subscription') + '</div>';
      if (hasPack) return '<div class="llc-rw">' + top + '<div class="llc-rw-row">' + tick + '20% off' + (d.gift ? ' and your free ' + esc(d.gift.short) : '') + ' unlocked</div></div>';
      var main = mainLine(), up = main && upgradeable(main);
      if (!up) return '<div class="llc-rw">' + top + '</div>';
      var tubs = main.qty, need = 3 - tubs;
      return '<div class="llc-rw">' + top + '<div class="llc-rw-sub">Add ' + need + ' more tub' + (need === 1 ? '' : 's') + ' to unlock 20% off' + (d.gift ? ' and your free ' + esc(d.gift.short) : '') + '</div><div class="llc-track"><span style="width:' + Math.round(tubs / 3 * 100) + '%"></span></div></div>';
    }
    var thr = freeThreshold(); if (!thr) return '';
    var total = d.total || 0;
    if (total >= thr) return '<div class="llc-rw"><div class="llc-rw-row">' + tick + 'You\'ve unlocked free ' + place + '</div></div>';
    var gap = thr - total;
    return '<div class="llc-rw"><div class="llc-rw-sub">You\'re <b>' + money(gap) + '</b> away from free ' + place + '</div><div class="llc-track"><span style="width:' + Math.max(4, Math.round(total / thr * 100)) + '%"></span></div></div>';
  }
  function upgradeable(it) {
    var k = kind(it);
    return SHOW.upgrade !== false && k === 'sub' && it.qty < 3 && it.pack_id && it.pack_price && !it.bundle && it.avail !== false;
  }
  function lineHtml(it) {
    var k = kind(it), d = st.data || {};
    var cmpLine = (it.cmp || it.price) * it.qty;
    var price = k === 'gift'
      ? '<s>' + money(cmpLine) + '</s><b class="llc-free">FREE</b>'
      : (cmpLine > it.line ? '<s>' + money(cmpLine) + '</s>' : '') + '<b>' + money(it.line) + '</b>';
    var pill = '';
    if (k === 'gift') pill = '<span class="llc-pill llc-pill--gift">Free gift</span>';
    else if (k === 'once') pill = '<span class="llc-pill llc-pill--once">One-time purchase</span>';
    else pill = '<span class="llc-pill">' + esc(planText(it)) + '</span>';
    var ctl = '';
    if (k === 'once') {
      ctl = '<div class="llc-qty" role="group" aria-label="Quantity"><button type="button" data-llc="dec" data-key="' + esc(it.key) + '" aria-label="One fewer">−</button><span>' + it.qty + '</span><button type="button" data-llc="inc" data-key="' + esc(it.key) + '" aria-label="One more">+</button></div>';
    } else if (k === 'pack') ctl = '<span class="llc-q">' + it.qty + ' tubs</span>';
    else if (k !== 'gift') ctl = '<span class="llc-q">Qty ' + it.qty + '</span>';
    var rm = k === 'gift' ? '' : '<button type="button" class="llc-rm" data-llc="rm" data-key="' + esc(it.key) + '">Remove</button>';
    var h = '<div class="llc-line llc-line--' + k + '"><a class="llc-img" href="' + esc(it.url) + '"><img src="' + esc(img(it.img, 160)) + '" alt="" width="64" height="64" loading="eager"></a>'
      + '<div class="llc-info"><a class="llc-t" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' + (it.vtitle ? '<div class="llc-vt">' + esc(it.vtitle) + '</div>' : '')
      + pill + (k === 'gift' ? '<div class="llc-vt">Comes with your 3-pack</div>' : '') + '<div class="llc-ctl">' + ctl + rm + '</div></div>'
      + '<div class="llc-pr">' + price + '</div>';
    /* 2026-10-20 (Ben: the offer boxes looked disconnected from the product above): the offer now
       renders INSIDE the line, under the product text, as an attached panel pointing up at it */
    var ml = mainLine();
    if (upgradeable(it)) { /* 2026-10-20 (Ben): every subscription line gets its own 3-pack offer, not just the main line */
      var packIn = lines().some(function (x) { return kind(x) === 'pack'; });
      var delta = it.pack_price * 3 - it.line;
      var n = (it.supply || 1) * 3;
      h += '<div class="llc-up"><div class="llc-up-t">Make this a 3-pack and save 20%</div><div class="llc-up-d">3 tubs together every ' + n + ' months' + (d.gift && !packIn ? ', plus free ' + esc(d.gift.short) + ' in your first box' : '') + '.</div>'
        + '<div class="llc-up-a"><span class="llc-up-p">' + money(it.pack_price * 3) + ' <small>(+' + money(delta) + ')</small></span><button type="button" class="llc-btn" data-llc="upgrade" data-key="' + esc(it.key) + '">Upgrade</button></div></div>';
    } else if (k === 'once' && SHOW.subscribe !== false && it.sub_id && it.sub_price && !it.gift) {
      var m = market(), perk = m === 'uk' ? ', free UK delivery' : (m === 'us' ? ', free US shipping' : '');
      h += '<div class="llc-sub"><div><b>Subscribe and save ' + (it.sub_disc || 10) + '%</b><div class="llc-vt">' + money(it.sub_price * it.qty) + ' instead of ' + money(it.line) + ', ' + every(it.supply || 1).toLowerCase() + perk + '. Skip or cancel any time.</div></div><button type="button" class="llc-btn llc-btn--ghost" data-llc="subscribe" data-key="' + esc(it.key) + '">Subscribe</button></div>';
    }
    return h + '</div>';
  }
  /* The pairing mirrors the main line: 3-pack -> its own 3-pack plan x3, subscription -> its own
     supply-matched ladder plan at the same quantity, one-time -> one-time. Plan ids are per product. */
  function pairOffer(p, main) {
    var k = main ? kind(main) : 'once';
    var v = p.variants && p.variants.length ? (p.variants.filter(function (x) { return x.id === p.id; })[0] || p.variants[0]) : { id: p.id, price: p.price };
    var vp = v.price || p.price;
    if ((k === 'pack' || k === 'prepaid') && p.pack_id && p.pack_price) {
      var unit = Math.round(vp * p.pack_price / p.price);
      return { id: v.id, qty: 3, plan: p.pack_id, price: unit * 3, cmp: vp * 3, text: '3 tubs together · save 20%' };
    }
    if ((k === 'sub' || k === 'pack' || k === 'prepaid') && p.sub_id && p.sub_price) {
      var q = (k === 'sub' && main) ? main.qty : 1;
      var u = Math.round(vp * p.sub_price / p.price);
      return { id: v.id, qty: q, plan: p.sub_id, price: u * q, cmp: vp * q, text: every(+p.supply || 1) + ' · save ' + (p.sub_disc || 10) + '%' };
    }
    if (k === 'sub' || k === 'pack' || k === 'prepaid') return null; /* never a one-time add-on in a subscription basket */
    return { id: v.id, qty: 1, plan: '', price: vp, cmp: vp, text: 'One-time purchase' };
  }
  function cardHtml(p, offer, src, title, note) {
    var opts = '';
    if (p.variants && p.variants.length > 1) {
      opts = '<select class="llc-sel" data-pid="' + p.pid + '" aria-label="Choose ' + esc(p.title) + ' option">' + p.variants.map(function (v) { return '<option value="' + v.id + '"' + (v.id === offer.id ? ' selected' : '') + '>' + esc(v.t) + '</option>'; }).join('') + '</select>';
    }
    return '<div class="llc-x-sec"><div class="llc-x-h">' + esc(title) + '</div><div class="llc-card"><a class="llc-img" href="' + esc(p.url) + '"><img src="' + esc(img(p.img, 160)) + '" alt="" width="56" height="56" loading="eager"></a>'
      + '<div class="llc-info"><a class="llc-t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' + (note ? '<div class="llc-why">' + esc(note) + '</div>' : '')
      + '<span class="llc-pill' + (offer.plan ? '' : ' llc-pill--once') + '">' + esc(offer.text) + '</span>' + opts + '</div>'
      + '<div class="llc-pr">' + (offer.cmp > offer.price ? '<s>' + money(offer.cmp) + '</s>' : '') + '<b>' + money(offer.price) + '</b><button type="button" class="llc-btn" data-llc="add" data-src="' + src + '" data-pid="' + p.pid + '">Add</button></div></div></div>';
  }
  var chosen = {}; /* pid -> variant id picked in a card select */
  function offersFor(list, main) {
    return list.map(function (p) {
      var q = Object.assign({}, p);
      if (chosen[p.pid]) { var v = (p.variants || []).filter(function (x) { return x.id === chosen[p.pid]; })[0]; if (v) { q = Object.assign({}, p, { id: v.id }); } }
      var o = pairOffer(q, main); return o ? { p: q, o: o } : null;
    }).filter(Boolean);
  }
  function suggestionsHtml() {
    var d = st.data || {}, main = mainLine(); if (!main) return { html: '', shown: [] };
    var out = '', shown = [];
    var mk = kind(main);
    var allOnce = realLines().every(function (i) { return kind(i) === 'once'; });
    var thr = freeThreshold(), gap = thr ? thr - (d.total || 0) : 0;
    var pairs = offersFor(d.pairs || [], main);
    if (allOnce && SHOW.gap !== false && gap > 0 && gap <= (CFG.gapMax || 3000)) {
      var pool = pairs.concat(offersFor((d.gap || []).map(function (g) { return Object.assign({ variants: [] }, g); }), main));
      var seen = {}; pool = pool.filter(function (x) { if (seen[x.p.pid]) return false; seen[x.p.pid] = 1; return market() !== 'us' || x.p.us; });
      var closers = pool.filter(function (x) { return x.o.price >= gap; }).sort(function (a, b) { return a.o.price - b.o.price; });
      var pick = closers[0] || pool.sort(function (a, b) { return b.o.price - a.o.price; })[0];
      if (pick) {
        out += cardHtml(pick.p, pick.o, 'drawer-gap', closers[0] ? 'Add this for free delivery' : 'Get closer to free delivery', firstSentence(pick.p.reason));
        shown.push(pick.p.pid);
      }
    }
    if (SHOW.pairs !== false) {
      var n = Math.max(1, Math.min(2, +CFG.pairs || 1)) - shown.length;
      if (mk === 'once' && shown.length) n = 0; /* one suggestion card at most in a one-time basket */
      var left = pairs.filter(function (x) { return shown.indexOf(x.p.pid) < 0 && (market() !== 'us' || x.p.us); }).slice(0, Math.max(0, n));
      left.forEach(function (x) { out += cardHtml(x.p, x.o, 'drawer-pairing', 'Complete your routine', firstSentence(x.p.reason)); shown.push(x.p.pid); });
    }
    return { html: out, shown: shown };
  }
  function giftHintHtml() {
    var d = st.data || {}; if (!d.gift) return '';
    var rl = realLines();
    var hasPack = rl.some(function (i) { var k = kind(i); return k === 'pack' || k === 'prepaid'; });
    var hasSub = rl.some(function (i) { return kind(i) === 'sub'; });
    if (hasPack || !hasSub) return '';
    var ml = mainLine(); if (ml && upgradeable(ml)) return ''; /* the 3-pack card already says it */
    return '<div class="llc-gh"><img src="' + esc(img(d.gift.img, 96)) + '" alt="" width="36" height="36"><div><b>Free ' + esc(d.gift.short) + '</b> with your 2nd delivery.</div></div>';
  }
  function trustHtml() {
    if (SHOW.trust === false) return '';
    var main = mainLine(), bits = [];
    if (main && +main.rating >= 4 && main.reviews >= 10) bits.push('<span class="llc-stars" aria-hidden="true">★</span> ' + (+main.rating).toFixed(1) + ' from ' + main.reviews + ' reviews');
    if (CFG.guarantee) bits.push(esc(CFG.guarantee));
    bits.push('<a href="' + esc(CFG.labUrl || '/pages/testing-procedures') + '">Lab tested: see the certificates</a>');
    return '<div class="llc-trust">' + bits.join('<span class="llc-dot" aria-hidden="true">·</span>') + '</div>';
  }
  /* 2026-10-29 (Ben): discount code box, as Boost had. Codes go on the cart via cart/update.js {discount},
     so they carry into checkout. A code the cart rejects (applicable:false) is taken straight back off
     and explained under the box, so it never sits there looking applied. */
  /* Liquid only lists codes that discount an item or the order; a free-shipping code shows up only in /cart.js,
     so /cart.js (checked after every apply/remove) is the source of truth and its accepted codes are merged in. */
  function codes() {
    var out = ((st.data || {}).codes || []).slice(), seen = {};
    out.forEach(function (c) { seen[c.code.toLowerCase()] = 1; });
    (st.ajaxCodes || []).forEach(function (c) { if (!seen[c.code.toLowerCase()]) { seen[c.code.toLowerCase()] = 1; out.push({ code: c.code, ok: !!c.applicable, held: !c.applicable }); } });
    return out;
  }
  /* 2026-10-29: a creator/link code (/discount/CODE) sits on the cart as applicable:false until the basket qualifies
     (creator codes are subscription-only). Show it as "saved" and never drop it when another code is applied or removed. */
  function keepCodes() { return codes().map(function (c) { return c.code; }); }
  var acT = null;
  function refreshCodes() { clearTimeout(acT); acT = setTimeout(function () { ajaxCodes().then(function () { render(); }); }, 250); }
  function ajaxCodes() { return _fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { st.ajaxCodes = c.discount_codes || []; return st.ajaxCodes; }).catch(function () { return st.ajaxCodes || []; }); }
  function codeHtml() {
    var chips = codes().filter(function (c) { return c.ok; }).map(function (c) {
      return '<span class="llc-chip"><svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8L3 12z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="7.5" cy="8.5" r="1.5" fill="currentColor"/></svg>' + esc(c.code)
        + '<button type="button" data-llc="uncode" data-code="' + esc(c.code) + '" aria-label="Remove code ' + esc(c.code) + '">×</button></span>';
    }).join('') + codes().filter(function (c) { return c.held; }).map(function (c) {
      return '<span class="llc-chip llc-chip--held" title="Saved on your basket">' + esc(c.code) + ' saved: not used on these items yet'
        + '<button type="button" data-llc="uncode" data-code="' + esc(c.code) + '" aria-label="Remove code ' + esc(c.code) + '">×</button></span>';
    }).join('');
    return '<form class="llc-code" data-llc-code novalidate><input type="text" name="code" placeholder="Discount code" autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="Discount code" value="' + esc(st.codeVal || '') + '"><button type="submit">Apply</button></form>'
      + (st.codeMsg ? '<div class="llc-code-msg" role="alert">' + esc(st.codeMsg) + '</div>' : '')
      + (chips ? '<div class="llc-chips">' + chips + '</div>' : '');
  }
  function setCodes(list) { return api('cart/update.js', { discount: list.join(',') }); }
  function applyCode(raw) {
    var code = String(raw || '').trim();
    if (!code) return;
    var have = keepCodes();
    if (have.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { st.codeVal = ''; st.codeMsg = ''; render(); return; }
    st.codeMsg = '';
    track('code_apply', { code: code });
    return setCodes(have.concat(code)).then(ajaxCodes).then(function (ac) {
      var hit = ac.filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
      if (hit && hit.applicable) { st.codeVal = ''; st.codeMsg = ''; render(); return; }
      st.codeVal = code;
      st.codeMsg = code.toUpperCase() + ' can\'t be used on this basket. Check the code, or see if it works on different items.';
      track('code_reject', { code: code });
      return setCodes(have).then(ajaxCodes).then(function () { render(); }); /* the cart keeps a rejected code (applicable:false); take it back off */
    });
  }
  function onSubmit(e) {
    var f = e.target.closest && e.target.closest('[data-llc-code]');
    if (!f) return;
    e.preventDefault();
    if (el.root.classList.contains('llc--busy')) return;
    applyCode(f.querySelector('input').value);
  }
  function onInput(e) { if (e.target && e.target.closest && e.target.closest('[data-llc-code]')) { st.codeVal = e.target.value; if (st.codeMsg) { st.codeMsg = ''; var m = el.root.querySelector('.llc-code-msg'); if (m) m.remove(); } } }
  function render() {
    if (!el.root) return;
    var d = st.data || { items: [] };
    el.n.textContent = d.count ? '(' + d.count + ')' : '';
    var msg = st.err ? '<div class="llc-err" role="alert">' + esc(st.err) + '</div>' : '';
    el.root.classList.toggle('llc--adding', !!st.adding);
    if (st.adding) msg += '<div class="llc-adding" role="status"><span class="llc-spin" aria-hidden="true"></span>Adding to your basket...</div>';
    var pend = st.adding && st.pend && st.pend.length ? '<div class="llc-lines llc-lines--pend">' + st.pend.map(pendHtml).join('') + '</div>' : '';
    if (pend) msg = msg.replace(/<div class="llc-adding"[\s\S]*?<\/div>/, '');
    if (st.adding && !d.count) { el.body.innerHTML = msg + (pend || '<div class="llc-skel"><span></span><span></span></div>'); el.ft.innerHTML = ''; el.ft.hidden = true; return; }
    if (!d.count) {
      el.body.innerHTML = msg + '<div class="llc-empty"><p>Your basket is empty.</p><a class="llc-btn" href="' + esc(CFG.emptyUrl || '/collections/all') + '">Shop our supplements</a></div>';
      el.ft.innerHTML = ''; el.ft.hidden = true; return;
    }
    el.ft.hidden = false;
    var mk = (mainLine() || {}).key;
    var rank = function (i) { return i.gift ? 2 : (i.key === mk ? 0 : 1); };
    var items = lines().map(function (i, n) { return { i: i, n: n }; }).sort(function (a, b) { return rank(a.i) - rank(b.i) || a.n - b.n; }).map(function (x) { return x.i; });
    var sug = suggestionsHtml();
    el.body.innerHTML = msg + rewardHtml() + pend + '<div class="llc-lines">' + items.map(lineHtml).join('') + '</div>' + giftHintHtml() + sug.html + trustHtml();
    var saving = 0;
    lines().forEach(function (i) { saving += (i.cmp || i.price) * i.qty - i.line; });
    var disc = (d.cart_discounts || []).map(function (c) { return '<div class="llc-row"><span>' + esc(c.title) + (c.pct ? ' (' + (+c.pct) + '% off)' : '') + '</span><span>−' + money(c.amount) + '</span></div>'; }).join('');
    saving += (d.cart_discounts || []).reduce(function (s, c) { return s + (c.amount || 0); }, 0);
    el.ft.innerHTML = codeHtml() + disc + '<div class="llc-row llc-row--tot"><span>Subtotal</span><span>' + money(d.total) + '</span></div>'
      + (saving > 0 ? '<div class="llc-row llc-save"><span>You\'re saving</span><span>' + money(saving) + '</span></div>' : '')
      + '<a class="llc-co" href="' + root + 'checkout" data-llc="checkout">Checkout</a>';
    st.shown = sug.shown;
    if (st.isOpen && sug.shown.length) sug.shown.forEach(function (pid) { if (!st.seen[pid]) { st.seen[pid] = 1; track('suggest_view', { pid: pid }); } });
  }
  st.seen = {};
  function bubble() {
    var n = (st.data && st.data.count) || 0;
    var icons = document.querySelectorAll('#cart-icon-bubble, #mobile-cart-icon-bubble');
    icons.forEach(function (ic) {
      var b = ic.querySelector('.cart-count-bubble');
      if (!n) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('span'); b.className = 'cart-count-bubble'; ic.appendChild(b); }
      b.classList.toggle('cart-count-bubble--dot', n >= 100);
      b.innerHTML = (n < 100 ? '<span aria-hidden="true">' + n + '</span>' : '') + '<span class="visually-hidden">' + n + ' item' + (n === 1 ? '' : 's') + '</span>';
    });
  }

  /* ---------- actions ---------- */
  function byKey(k) { return lines().filter(function (i) { return i.key === k; })[0]; }
  function props(it, src) { var p = (it.props && !Array.isArray(it.props)) ? Object.assign({}, it.props) : {}; if (src) p._lls_src = src; return p; }
  function onChange(e) {
    var s = e.target.closest && e.target.closest('.llc-sel');
    if (!s) return;
    chosen[+s.getAttribute('data-pid')] = +s.value; render();
  }
  function onClick(e) {
    var b = e.target.closest && e.target.closest('[data-llc]');
    if (!b) return;
    var a = b.getAttribute('data-llc'), key = b.getAttribute('data-key'), it = key ? byKey(key) : null;
    if (a === 'close') { e.preventDefault(); close(); return; }
    if (a === 'checkout') { track('checkout', { value: (st.data || {}).total }); return; }
    if (el.root.classList.contains('llc--busy')) { e.preventDefault(); return; }
    if (a === 'uncode') { var rc = b.getAttribute('data-code'); track('code_remove', { code: rc }); st.codeMsg = ''; return setCodes(keepCodes().filter(function (c) { return c !== rc; })).then(ajaxCodes).then(function () { render(); }); }
    if (a === 'inc' && it) return api('cart/change.js', { id: it.key, quantity: it.qty + 1 });
    if (a === 'dec' && it) return api('cart/change.js', { id: it.key, quantity: Math.max(0, it.qty - 1) });
    if (a === 'rm' && it) { track('remove', { handle: it.handle }); return api('cart/change.js', { id: it.key, quantity: 0 }); }
    if (a === 'upgrade' && it) {
      track('upgrade', { handle: it.handle, value: it.pack_price * 3 - it.line });
      return api('cart/change.js', { id: it.key, quantity: 3, selling_plan: +it.pack_id, properties: props(it, 'drawer-upgrade') });
    }
    if (a === 'subscribe' && it) {
      track('subscribe', { handle: it.handle });
      return api('cart/change.js', { id: it.key, quantity: it.qty, selling_plan: +it.sub_id, properties: props(it, 'drawer-subscribe') });
    }
    if (a === 'add') {
      var pid = +b.getAttribute('data-pid'), src = b.getAttribute('data-src') || 'drawer-pairing';
      var d = st.data || {}, pool = (d.pairs || []).concat((d.gap || []).map(function (g) { return Object.assign({ variants: [] }, g); }));
      var x = offersFor(pool.filter(function (p) { return p.pid === pid; }).slice(0, 1), mainLine())[0];
      if (!x) return;
      var item = { id: x.o.id, quantity: x.o.qty, properties: { _lls_src: src } };
      if (x.o.plan) item.selling_plan = +x.o.plan;
      track(src === 'drawer-gap' ? 'gap_add' : 'pair_add', { handle: x.p.handle, value: x.o.price });
      return api('cart/add.js', { items: [item] });
    }
  }

  /* ---------- open / close ---------- */
  function open() {
    build();
    if (!st.isOpen) {
      st.lastFocus = document.activeElement;
      st.isOpen = true;
      el.root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('llc-lock');
      el.root.classList.add('llc--open'); el.ov.classList.add('llc--open');
      setTimeout(function () { try { el.root.querySelector('.llc-x').focus({ preventScroll: true }); } catch (e) {} }, 30);
      track('open', { items: (st.data || {}).count || 0 });
    }
    render();
    if (!st.pending && Date.now() - st.t > 30000) fetchData(); /* another tab may have changed the cart */
  }
  function close() {
    if (!st.isOpen) return;
    st.isOpen = false; st.err = '';
    el.root.classList.remove('llc--open'); el.ov.classList.remove('llc--open');
    el.root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('llc-lock');
    try { if (st.lastFocus && st.lastFocus.focus) st.lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  /* Callers do: add -> Boost.Cart.refresh() -> Boost.Cart.open(). The add response may still be
     parsing, so wait for in-flight cart data before showing (no flash of the old basket). */
  function openSettled() { build(); settled().then(open); }
  function refresh() {
    if (st.pending) return settled().then(render);
    if (Date.now() - st.t < 1500) { render(); return Promise.resolve(); }
    return fetchData();
  }
  window.__llsCart = { open: openSettled, close: close, refresh: refresh, data: function () { return st.data; } };
  window.Boost = window.Boost || {};
  window.Boost.Cart = { open: openSettled, refresh: refresh, close: close };

  /* Shopper add buttons that get the instant open. The PDP one-time link (#lls-onetime-link, a div
     that adds 1 tub at full price) and the answer block's "buy once" button were missing until
     2026-10-16, so one-time adds waited the full ~0.8-1.4s add round trip before the drawer showed. */
  var ATC = '#lls-cta-btn, #lls-sticky-atc, #lls-fbt-atc, #lls-onetime-link, .ap-btn, .lls-ap [data-mode], [data-lls-atc]';
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(ATC)) st.expect = Date.now();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && st.isOpen) close(); });
  /* Header cart icon (a link to /cart while the theme's own drawer is off) opens the drawer. */
  document.addEventListener('click', function (e) {
    if (CFG.page === 'cart') return;
    var t = e.target.closest && e.target.closest('#cart-icon-bubble, #mobile-cart-icon-bubble, a.header__icon--cart, a[href="/cart"], a[href="' + root + 'cart"]');
    if (!t || (el.root && el.root.contains(t))) return;
    e.preventDefault(); e.stopPropagation();
    openSettled();
  }, true);
  var rt = null;
  document.addEventListener('cart:refresh', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { if (!st.pending && Date.now() - st.t > 1500) fetchData(); }, 400);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchData(); });

  st.data = initial(); st.t = Date.now();
  bubble(); if ((st.data || {}).count) ajaxCodes();
  var Q = window.__llsCartQ || [];
  if (Q.length) { if (Q.indexOf('open') >= 0) openSettled(); else refresh(); }
  Q.length = 0; Q.push = function (a) { if (a === 'open') openSettled(); else refresh(); };
})();
